import { Palette } from '@mui/material'

export const linkStyle = (palette: Palette) => ({
	textUnderlineOffset: '4px',
	color: palette.brand.main,
	fontSize: '14px',
})

export const logoutIconStyle = {
	width: '18px',
	marginRight: '10px',
}
